import { render, staticRenderFns } from "./TravellerProfile.vue?vue&type=template&id=88d5cd32&lang=pug"
import script from "./TravellerProfile.vue?vue&type=script&lang=js"
export * from "./TravellerProfile.vue?vue&type=script&lang=js"
import style0 from "./TravellerProfile.vue?vue&type=style&index=0&id=88d5cd32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports